// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1mUsM","buttons":"SendReceipts_buttons__SUtEZ","email":"SendReceipts_email__1_3pH","bookApptTitle":"SendReceipts_bookApptTitle__2YPUe"};